import { lazy, Suspense } from 'react'

const CareermindsPostProgram = lazy(() => import('./CareermindsPostProgram'))

export const CareermindsPostProgramView = () => {
  return (
    <Suspense fallback={null}>
      <CareermindsPostProgram />
    </Suspense>
  )
}
